import { render, staticRenderFns } from "./MovementList.vue?vue&type=template&id=576ec1da"
import script from "./MovementList.vue?vue&type=script&lang=js"
export * from "./MovementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports